/* tslint:disable */
export const DemoModel = {
  generatorVersion: '3.0',
  primaryKeyString: 'FormID',
  primaryKeys: [],
  header: {
    defaultTitle: '',
  },
  description: {
    defaultTitle: '',
  },
  dataSource: {
    type: 'DB',
    name: 'EP_Form',
    _sqlView: 'vw_EP_Form',
    sqlTable: 'EP_Form',
    sqlView: 'vw_EP_Form',
  },
  defaultFormName: 'default',
  defaultViewName: 'default',
  fieldCollection: [
    {
      name: 'FormID',
      fieldType: 4,
      dbTypeName: 'Guid',
      format: '',
      title: 'ID',
      description: '',
      maxLength: '',
      isSystemRequired: true,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CaseID',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'CaseID',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_Cases',
        viewName: 'default',
        name: 'EP_Cases:default',
        evidence: 'EP_Cases/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CreatedOn',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Created On',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CreatedBy',
      fieldType: 4,
      dbTypeName: 'Guid',
      format: '',
      title: 'Created By',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Membership',
        viewName: 'default',
        name: 'aspnet_Membership:default',
        evidence: 'aspnet_Membership/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CreatedIP',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Created IP',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantChoice',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'Applicant Choice',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantFirstName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ApplicantFirstName',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantLastName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ApplicantLastName',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantMiddleName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ApplicantMiddleName',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantFullName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Applicant Full Name',
      description: '',
      maxLength: '152',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantSex',
      fieldType: 2,
      dbTypeName: 'Int16',
      format: '',
      title: 'ApplicantSex',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantBirthDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Birth Date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantPosition',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Applicant Position',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantIDNP',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'IDNP',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantPhone',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ApplicantPhone',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantEmail',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ApplicantEmail',
      description: '',
      maxLength: '254',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Notes',
      fieldType: 4,
      dbTypeName: 'String',
      format: 'textarea',
      title: 'Notes',
      description: '',
      maxLength: '2147483647',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressDistrict',
      fieldType: 1,
      dbTypeName: 'Int16',
      format: '',
      title: 'AddressDistrict',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Districts',
        viewName: 'default',
        name: 'EP_DIC_Districts:default',
        evidence: 'EP_DIC_Districts/default',
      },
      bindings: [
        {
          from: 'ApplicantAddressCountry',
          to: 'CountryId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressCity',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'AddressCity',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'vw_EP_Localities',
        viewName: 'default',
        name: 'vw_EP_Localities:default',
        evidence: 'vw_EP_Localities/default',
      },
      bindings: [
        {
          from: 'ApplicantAddressDistrict',
          to: 'DistrictId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressSector',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'AddressSector',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Localities',
        viewName: 'Sector',
        name: 'EP_DIC_Localities:Sector',
        evidence: 'EP_DIC_Localities/Sector',
      },
      bindings: [
        {
          from: 'ApplicantAddressCity',
          to: 'ParentId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressStreet',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'ApplicantAddressStreet',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Streets',
        viewName: 'default',
        name: 'EP_DIC_Streets:default',
        evidence: 'EP_DIC_Streets/default',
      },
      bindings: [
        {
          from: 'ApplicantAddressCity',
          to: 'LocalityId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressPostalCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressPostalCode',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressHouse',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressHouse',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressBlock',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressBlock',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressEntrance',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressEntrance',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressFloor',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressFloor',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressApartment',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressApartment',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'default',
        name: 'EP_DIC_Countries:default',
        evidence: 'EP_DIC_Countries/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectDistrict',
      fieldType: 1,
      dbTypeName: 'Int16',
      format: '',
      title: 'ReObjectDistrict',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Districts',
        viewName: 'default',
        name: 'EP_DIC_Districts:default',
        evidence: 'EP_DIC_Districts/default',
      },
      bindings: [
        {
          from: 'ReObjectCountry',
          to: 'CountryId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectCity',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'ReObjectCity',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'vw_EP_Localities',
        viewName: 'default',
        name: 'vw_EP_Localities:default',
        evidence: 'vw_EP_Localities/default',
      },
      bindings: [
        {
          from: 'ReObjectDistrict',
          to: 'DistrictId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectSector',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'ReObjectSector',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Localities',
        viewName: 'Sector',
        name: 'EP_DIC_Localities:Sector',
        evidence: 'EP_DIC_Localities/Sector',
      },
      bindings: [
        {
          from: 'ReObjectCity',
          to: 'ParentId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectPostalCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ReObjectPostalCode',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectStreet',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'ReObjectStreet',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Streets',
        viewName: 'default',
        name: 'EP_DIC_Streets:default',
        evidence: 'EP_DIC_Streets/default',
      },
      bindings: [
        {
          from: 'ReObjectCity',
          to: 'LocalityId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectHouse',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'ReObjectHouse',
      description: '',
      maxLength: '10',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectCadastrFileNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ReObjectCadastrFileNumber',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectLandParcelFileNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ReObjectLandParcelFileNumber',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectTopographicalNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ReObjectTopographicalNumber',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectCadastruId',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ReObjectCadastruId',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectParcelArea',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ReObjectParcelArea',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectAreaOfDesigned',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ReObjectAreaOfDesigned',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PurposeText',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'PurposeText',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantType',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'ApplicantType',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_PersonsCategory',
        viewName: 'default',
        name: 'EP_DIC_PersonsCategory:default',
        evidence: 'EP_DIC_PersonsCategory/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: true,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectIsMonument',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'ReObjectIsMonument',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectIsSpecialZone',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'ReObjectIsSpecialZone',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TradeUnitName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'TradeUnitName',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TradeUnitType',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'TradeUnitType',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_CommercialUnits',
        viewName: 'lookup',
        name: 'EP_DIC_CommercialUnits:lookup',
        evidence: 'EP_DIC_CommercialUnits/lookup',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NumberOfJobsBoxesPCs',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'NumberOfJobsBoxesPCs',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TradeAreaM2',
      fieldType: 7,
      dbTypeName: 'Double',
      format: '',
      title: 'TradeAreaM2',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'IsLivingBuilding',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'IsLivingBuilding',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'IsAuthorization',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'IsAuthorization',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'WorkProgram',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'WorkProgram',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DaysOff',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'DaysOff',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TradingActivities',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'TradingActivities',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormTraidingActivities',
        gridName: 'Grid',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'PermitTypeId',
            value: '[PermitTypeId]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'MedicalActivities',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Medical Activities',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_DIC_CaseMedActivities',
        gridName: 'Grid',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ActivityType',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Activity Type',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'vw_EP_LicToPermit',
        viewName: 'lookup',
        name: 'vw_EP_LicToPermit:lookup',
        evidence: 'vw_EP_LicToPermit/lookup',
      },
      bindings: [
        {
          from: 'PermitTypeId',
          to: 'PermitTypeId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'SanitaryProducts',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Products',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'PublicProducts',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'TradedGoodsGroup',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'TradedGoodsGroup',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TotalNumberOfRestaurantSeats',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'TotalNumberOfRestaurantSeats',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NumberOfTerraceOnlySeats',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'NumberOfTerraceOnlySeats',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'isSellingAlcohol',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'isSellingAlcohol',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'isSellingBeer',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'isSellingAlcohol',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'isSellingTobacco',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'isSellingTobacco',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'isPedlary',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'isPedlary',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'isMobileUnit',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'isMobileUnit',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'isDevices',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'isDevices',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'MobileUnitLength',
      fieldType: 7,
      dbTypeName: 'Double',
      format: '',
      title: 'MobileUnitLength',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'MobileUnitWidth',
      fieldType: 7,
      dbTypeName: 'Double',
      format: '',
      title: 'MobileUnitWidth',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'MobileUnitHeight',
      fieldType: 7,
      dbTypeName: 'Double',
      format: '',
      title: 'MobileUnitHeight',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'MobileUnitType',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'MobileUnitType',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ProductTypes',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'Product Types',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'publicFood',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'publicFood',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PermitTypeId',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Permit Type',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_PermitTypes',
        viewName: 'lookup',
        name: 'EP_PermitTypes:lookup',
        evidence: 'EP_PermitTypes/lookup',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantDocuments',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Applicant Documents',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_CaseDocuments',
        gridName: 'ApplicantDocuments',
        columns: [
          {
            name: 'CaseID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'InternalDocuments',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'InternalDocuments',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_CaseDocuments',
        gridName: 'CaseInternalDocumentsEdit',
        columns: [
          {
            name: 'CaseID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'SpecialistId',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'Specialist',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Membership',
        viewName: 'default',
        name: 'aspnet_Membership:default',
        evidence: 'aspnet_Membership/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CasePermitTypeId',
      fieldType: 2,
      dbTypeName: 'Int16',
      format: '',
      title: 'Permit Type',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_PermitTypes',
        viewName: 'lookup',
        name: 'EP_PermitTypes:lookup',
        evidence: 'EP_PermitTypes/lookup',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: true,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AuthorityId',
      fieldType: 1,
      dbTypeName: 'Int16',
      format: '',
      title: 'AuthorityId',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_Authorities',
        viewName: 'lookup',
        name: 'EP_Authorities:lookup',
        evidence: 'EP_Authorities/lookup',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PermitProcessingTeamId',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'Processing Team',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Teams',
        viewName: 'lookup',
        name: 'aspnet_Teams:lookup',
        evidence: 'aspnet_Teams/lookup',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'SupportingDocuments',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Supporting Documents',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'AX_DF_Document',
        gridName: 'ApplicantDocuments',
        columns: [
          {
            name: 'ObjectId',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'CommercialType',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Commercial Type',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_AriaType',
        viewName: 'default',
        name: 'EP_DIC_AriaType:default',
        evidence: 'EP_DIC_AriaType/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectBlock',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'ReObjectBlock',
      description: '',
      maxLength: '10',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectApartment',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'ReObjectApartment',
      description: '',
      maxLength: '10',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectArea',
      fieldType: 7,
      dbTypeName: 'Double',
      format: '',
      title: 'ReObjectArea',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NumberOfDevices',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'Number of devices',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DeviceLength',
      fieldType: 7,
      dbTypeName: 'Double',
      format: '',
      title: 'DeviceLength',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DeviceWidth',
      fieldType: 7,
      dbTypeName: 'Double',
      format: '',
      title: 'DeviceWidth',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DeviceHeight',
      fieldType: 7,
      dbTypeName: 'Double',
      format: '',
      title: 'DeviceHeight',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectPhone',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'reObjectPhone',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectFax',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'reObjectFax',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegComNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'RegComNumber',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegComDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'RegComDate',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'WorksType',
      fieldType: 2,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'WorksType',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Conditions',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Conditions',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ArchitecturalDesignNr',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ArchitecturalDesignNr',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TermStart',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'TermStart',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DurationWorks',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'DurationWorks',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BuildArea',
      fieldType: 7,
      dbTypeName: 'Decimal',
      format: '',
      title: 'Build area, m2',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ArchitecturalDesignDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Architectural design date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ArchitecturalDesignIssuedBy',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Architectural design issued by',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DesignerCity',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Designer City',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'vw_EP_Localities',
        viewName: 'default',
        name: 'vw_EP_Localities:default',
        evidence: 'vw_EP_Localities/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DesignerStreet',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Designer Street',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Streets',
        viewName: 'default',
        name: 'EP_DIC_Streets:default',
        evidence: 'EP_DIC_Streets/default',
      },
      bindings: [
        {
          from: 'DesignerCity',
          to: 'LocalityId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DesignerHouseNr',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Designer House Nr',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DesignerApartment',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Designer Apartment',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'VerifiedByCoordinationNr',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Verified by (Coordination nr)',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'VerifiedByName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Verified by (Name)',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'VerifiedByCertificationNr',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Verified by (Certification nr)',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolishedDescription',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'DemolishedDescription',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionProjectNr',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Demolition Project Nr',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionProjectDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Demolition Project Date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionIssuedBy',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Demolition project issued by',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionArchitectCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Applicant Address Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'default',
        name: 'EP_DIC_Countries:default',
        evidence: 'EP_DIC_Countries/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionArchitectDistrict',
      fieldType: 1,
      dbTypeName: 'Int16',
      format: '',
      title: 'DemolitionArchitectDistrict',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Districts',
        viewName: 'default',
        name: 'EP_DIC_Districts:default',
        evidence: 'EP_DIC_Districts/default',
      },
      bindings: [
        {
          from: 'DemolitionArchitectCountry',
          to: 'CountryId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionArchitectCity',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'DemolitionArchitectCity',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'vw_EP_Localities',
        viewName: 'default',
        name: 'vw_EP_Localities:default',
        evidence: 'vw_EP_Localities/default',
      },
      bindings: [
        {
          from: 'DemolitionArchitectDistrict',
          to: 'DistrictId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionArchitectSector',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'DemolitionArchitectSector',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Localities',
        viewName: 'Sector',
        name: 'EP_DIC_Localities:Sector',
        evidence: 'EP_DIC_Localities/Sector',
      },
      bindings: [
        {
          from: 'DemolitionArchitectCity',
          to: 'ParentId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionArchitectStreet',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'DemolitionArchitectStreet',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Streets',
        viewName: 'default',
        name: 'EP_DIC_Streets:default',
        evidence: 'EP_DIC_Streets/default',
      },
      bindings: [
        {
          from: 'DemolitionArchitectCity',
          to: 'LocalityId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionArchitectAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Demolition Architect Address',
      description: '',
      maxLength: '1000',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionArchitectPostalCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'DemolitionArchitectPostalCode',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionArchitectHouse',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'DemolitionArchitectHouse',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DemolitionArchitectApartment',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'DemolitionArchitectApartment',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CurrentZoneType',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'CurrentZoneType',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NewZoneType',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'NewZoneType',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ValueMDL',
      fieldType: 7,
      dbTypeName: 'Double',
      format: '',
      title: 'ValueMDL',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BankAccountNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Bank Account Number',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BankCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Bank Code',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BankName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Bank Name',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'VATRegNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'VATRegNumber',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AdvertisingObjectType',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AdvertisingObjectType',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AdvertisingText',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'AdvertisingText',
      description: '',
      maxLength: '2147483647',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AdvertisingArea',
      fieldType: 7,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Build area, m2',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'IlluminatedOutside',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: 'radio',
      title: 'IlluminatedOutside',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'IlluminatedInside',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: 'radio',
      title: 'IlluminatedInside',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NotIlluminated',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: 'radio',
      title: 'NotIlluminated',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TechnicallyImpossible',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: 'radio',
      title: 'TechnicallyImpossible',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DetailedPlaceDesc',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'DetailedPlaceDesc',
      description: '',
      maxLength: '500',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AuthorizationNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AuthorizationNumber',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AuthorizationDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'AuthorizationDate',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'WayIssue',
      fieldType: 2,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'WayIssue',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PeriodExportFrom',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'PeriodExportFrom',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PeriodExportTo',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'PeriodExportTo',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DestinationCompany',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Destination Company',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DestinationCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Destination Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountries',
        name: 'EP_DIC_Countries:lookupCountries',
        evidence: 'EP_DIC_Countries/lookupCountries',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NumberAuthTransportation',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'NumberAuthTransportation',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DateAuthTransportation',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'DateAuthTransportation',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CustomsPoint',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'CustomsPoint',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CheifCommercialUnit',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'CheifCommercialUnit',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BranchCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'BranchCode',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'IBAN',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'IBAN',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PatentType',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'Patent Type',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_BusinessPatents',
        viewName: 'lookup',
        name: 'EP_DIC_BusinessPatents:lookup',
        evidence: 'EP_DIC_BusinessPatents/lookup',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: true,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TransportType',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'TransportType',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_TransportTypes',
        viewName: 'default',
        name: 'EP_DIC_TransportTypes:default',
        evidence: 'EP_DIC_TransportTypes/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TransportNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Transport',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Holder',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Holder',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Expeditor',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Expeditor',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExportingCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Exporting Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountries',
        name: 'EP_DIC_Countries:lookupCountries',
        evidence: 'EP_DIC_Countries/lookupCountries',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PayingCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Paying Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountries',
        name: 'EP_DIC_Countries:lookupCountries',
        evidence: 'EP_DIC_Countries/lookupCountries',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ImportingCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Importing Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountries',
        name: 'EP_DIC_Countries:lookupCountries',
        evidence: 'EP_DIC_Countries/lookupCountries',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'OtherTransitCountries',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Other Transit Countries',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormOtherTransitCountries',
        gridName: 'TransitCountries',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ValidityTermRequested',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ValidityTermRequested',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Products',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Products',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'Products',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'MedicineProducts',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Products',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'Medicine',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'CommercialName',
            value: 'Medicamente',
          },
          {
            name: 'Code',
            value: '5366',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ProductsCEFTA',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Products',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'ProductsCEFTA',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'PermitTypeId',
            value: '[PermitTypeId]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ProductsSugar',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Products',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'ProductsSugar',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'PermitTypeId',
            value: '[PermitTypeId]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Transporter',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Transporter',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TotalQuantity',
      fieldType: 7,
      dbTypeName: 'Decimal',
      format: '',
      title: 'Total Quantity',
      description: '',
      maxLength: '3',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'QuantityUnits',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Quantity units',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_QuantityUnits',
        viewName: 'default',
        name: 'EP_DIC_QuantityUnits:default',
        evidence: 'EP_DIC_QuantityUnits/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ValueCIF',
      fieldType: 7,
      dbTypeName: 'Decimal',
      format: '',
      title: 'ValueCIF',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'EntryCustomsPoint',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Entry customs point',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Customs',
        viewName: 'default',
        name: 'EP_DIC_Customs:default',
        evidence: 'EP_DIC_Customs/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExitCustomsPoint',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Exit customs point',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Customs',
        viewName: 'default',
        name: 'EP_DIC_Customs:default',
        evidence: 'EP_DIC_Customs/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TransitRouteMoldova',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Transit route in Moldova',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'OtherApplicantInformation',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'OtherApplicantInformation',
      description: '',
      maxLength: '500',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExternalPartner',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ExternalPartner',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'OriginCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Origin country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountries',
        name: 'EP_DIC_Countries:lookupCountries',
        evidence: 'EP_DIC_Countries/lookupCountries',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DeliveryConditions',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'DeliveryConditions',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Supplier',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Supplier',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PaymentConditions',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'PaymentConditions',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PaymentConditionsCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'PaymentConditionsCode',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PaymentCurrency',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Payment Currency',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Currencies',
        viewName: 'default',
        name: 'EP_DIC_Currencies:default',
        evidence: 'EP_DIC_Currencies/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegNumberME',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'RegNumberME',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegDateME',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'RegDateME',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegNumberExporter',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'RegNumberExporter',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegDateExporter',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'RegDateExporter',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicationFileID',
      fieldType: 4,
      dbTypeName: '',
      format: '',
      title: 'ApplicationFileID',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ArchitecturalDesign',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Architectural Design',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'QuantityKg',
      fieldType: 6,
      dbTypeName: 'Double',
      format: '',
      title: 'Quantity Kg',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Quantity',
      fieldType: 6,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Quantity',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ProducedBy',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Produced By',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExportedBy',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Exported By',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ProductName',
      fieldType: 1,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ProductName',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Products',
        viewName: 'Nuclear',
        name: 'EP_DIC_Products:Nuclear',
        evidence: 'EP_DIC_Products/Nuclear',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegNumberCom',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'RegNumberCom',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegDateCom',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'RegDateCom',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ProductsPhytosanitary',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Products Phytosanitary',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'ProductsPhytosanitary',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'DepositedComUnit',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'DepositedComUnit',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DepositorAuthNumberSV',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'DepositorAuthNumberSV',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DepositorAuthNumberDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'DepositorAuthNumberDate',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Drugs',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Drugs',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'Drugs',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'DrugsRegistration',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Drugs Registration',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'DrugsRegistration',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'DrugsAuthorization',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Drugs Authorization',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'DrugsAuthorization',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'DrugsAuthorizationSp',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Drugs Authorization',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'DrugsAuthorizationSp',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'IsSpecialistDrugs',
            value: "'0'",
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Installations',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Installations',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'Installations',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ContactPersonFirstName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ContactPersonFirstName',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ContactPersonLastName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ContactPersonLastName',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ContactPersonPhone',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ContactPersonPhone',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'OtherInformation',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'OtherInformation',
      description: '',
      maxLength: '500',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CheifFirstName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'CheifFirstName',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CheifLastName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'CheifLastName',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Exporter',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Exporter',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExporterAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ExporterAddress',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExporterPhone',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ExporterPhone',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Importer',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Importer',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ImporterAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ImporterAddress',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ImporterPhone',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ImporterPhone',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegNumberImporter',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'RegNumberImporter',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegDateImporter',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'RegDateImporter',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ImporterFax',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ImporterFax',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExporterFax',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ExporterFax',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DestinationAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'DestinationAddress',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TransportationWay',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'TransportationWay',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryIDNO',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'BeneficiaryIDNO',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryIDNPO',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Beneficiary IDNPO',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryFirstName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'BeneficiaryFirstName',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryLastName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'BeneficiaryLastName',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryBirthDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Birth Date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryPhone',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'BeneficiaryPhone',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryEmail',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'BeneficiaryEmail',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressDistrict',
      fieldType: 1,
      dbTypeName: 'Int16',
      format: '',
      title: 'AddressDistrict',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Districts',
        viewName: 'default',
        name: 'EP_DIC_Districts:default',
        evidence: 'EP_DIC_Districts/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressCity',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'AddressCity',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'vw_EP_Localities',
        viewName: 'default',
        name: 'vw_EP_Localities:default',
        evidence: 'vw_EP_Localities/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressSector',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'AddressSector',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Localities',
        viewName: 'Sector',
        name: 'EP_DIC_Localities:Sector',
        evidence: 'EP_DIC_Localities/Sector',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressStreet',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'BeneficiaryAddressStreet',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Streets',
        viewName: 'default',
        name: 'EP_DIC_Streets:default',
        evidence: 'EP_DIC_Streets/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressPostalCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressPostalCode',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressHouse',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressHouse',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressBlock',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressBlock',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressEntrance',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressEntrance',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressFloor',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressFloor',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressApartment',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'AddressApartment',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryType',
      fieldType: 6,
      dbTypeName: 'Int16',
      format: '',
      title: 'Beneficiary Type',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Beneficiary Address',
      description: '',
      maxLength: '1000',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryFullName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Beneficiary Full Name',
      description: '',
      maxLength: '101',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeIDNP',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative IDNP',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeBirthDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Representative Birth Date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativePhone',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative Phone',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeEmail',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative Email',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressDistrict',
      fieldType: 1,
      dbTypeName: 'Int16',
      format: '',
      title: 'Representative AddressDistrict',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Districts',
        viewName: 'default',
        name: 'EP_DIC_Districts:default',
        evidence: 'EP_DIC_Districts/default',
      },
      bindings: [
        {
          from: 'RepresentativeAddressCountry',
          to: 'CountryId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressCity',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Representative AddressCity',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'vw_EP_Localities',
        viewName: 'default',
        name: 'vw_EP_Localities:default',
        evidence: 'vw_EP_Localities/default',
      },
      bindings: [
        {
          from: 'RepresentativeAddressDistrict',
          to: 'DistrictId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressSector',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Representative AddressSector',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Localities',
        viewName: 'Sector',
        name: 'EP_DIC_Localities:Sector',
        evidence: 'EP_DIC_Localities/Sector',
      },
      bindings: [
        {
          from: 'RepresentativeAddressCity',
          to: 'ParentId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressStreet',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Representative AddressStreet',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Streets',
        viewName: 'default',
        name: 'EP_DIC_Streets:default',
        evidence: 'EP_DIC_Streets/default',
      },
      bindings: [
        {
          from: 'RepresentativeAddressCity',
          to: 'LocalityId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressPostalCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative AddressPostalCode',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressHouse',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative AddressHouse',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressBlock',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative AddressBlock',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressEntrance',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative AddressEntrance',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressFloor',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative AddressFloor',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressApartment',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative AddressApartment',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative Address',
      description: '',
      maxLength: '1000',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeFullName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative Full Name',
      description: '',
      maxLength: '201',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeFirstName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'RepresentativeFirstName',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeLastName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'RepresentativeLastName',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeType',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'RepresentativeType',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'LegalEntityName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'LegalEntityName',
      description: '',
      maxLength: '200',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Reason',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'Reason',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NetworkCategory',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Network Category',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_NetworkCategory',
        viewName: 'NetworkCategory',
        name: 'EP_DIC_NetworkCategory:NetworkCategory',
        evidence: 'EP_DIC_NetworkCategory/NetworkCategory',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NetworkType',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Network Type',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_NetworkType',
        viewName: 'NetworkType',
        name: 'EP_DIC_NetworkType:NetworkType',
        evidence: 'EP_DIC_NetworkType/NetworkType',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NetworkPurpose',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Network Purpose',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_NetworkPurpose',
        viewName: 'NetworkPurpose',
        name: 'EP_DIC_NetworkPurpose:NetworkPurpose',
        evidence: 'EP_DIC_NetworkPurpose/NetworkPurpose',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AgreePublishContacts',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'Agree to publish contacts',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegCertificateNr',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Registration certificate nr',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegCertificateDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Registration certificate date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RegOffice',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Registration certificate date',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'LetterAttorneyDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Letter of attorney date',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TradingUnits',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Trading units',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormUnits',
        gridName: 'Units',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'RequestDelivery',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'Request delivery',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DeliveryPostalCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Delivery Postal Code',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DeliveryCity',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Delivery City',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'vw_EP_Localities',
        viewName: 'default',
        name: 'vw_EP_Localities:default',
        evidence: 'vw_EP_Localities/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DeliveryAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Delivery Address',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PackageType',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Package Type',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Origin',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Origin',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Route',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Route',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Quote',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Year / Quote',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'YearQuote',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Requested for Year',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DestinationCountryCode',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Destination Country Code',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountriesCode',
        name: 'EP_DIC_Countries:lookupCountriesCode',
        evidence: 'EP_DIC_Countries/lookupCountriesCode',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PayingCountryCode',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Paying Country Code',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountriesCode',
        name: 'EP_DIC_Countries:lookupCountriesCode',
        evidence: 'EP_DIC_Countries/lookupCountriesCode',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExportingCountryCode',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Exporting Country Code',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountriesCode',
        name: 'EP_DIC_Countries:lookupCountriesCode',
        evidence: 'EP_DIC_Countries/lookupCountriesCode',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ImportingCountryCode',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Importing Country Code',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountriesCode',
        name: 'EP_DIC_Countries:lookupCountriesCode',
        evidence: 'EP_DIC_Countries/lookupCountriesCode',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'OriginCountryCode',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Origin Country Code',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'lookupCountriesCode',
        name: 'EP_DIC_Countries:lookupCountriesCode',
        evidence: 'EP_DIC_Countries/lookupCountriesCode',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicationTemplateName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Application Template Name',
      description: '',
      maxLength: '512',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PermitTemplateName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Permit Template Name',
      description: '',
      maxLength: '512',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RejectionTemplateName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Rejection Template Name',
      description: '',
      maxLength: '512',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TableNameApplicant',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Table Name Applicant',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'InputFormApplicant',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Input Form Applicant',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TableNameSpecialist',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Table Name Specialist',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'InputFormSpecialist',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Input Form Specialist',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TableNameExpert',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Table Name Expert',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'InputFormExpert',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Input Form Expert',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CaseNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Case Number',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Status',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'Status',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'StatusResult',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'Decision on case',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicationDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Application Date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantID',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'ApplicantID',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'AspNetUsers',
        viewName: 'defaultAll',
        name: 'AspNetUsers:defaultAll',
        evidence: 'AspNetUsers/defaultAll',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Description',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'Description',
      description: '',
      maxLength: '2000',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ModifiedOn',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Modified On',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ModifiedBy',
      fieldType: 4,
      dbTypeName: 'Guid',
      format: '',
      title: 'Modified By',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Membership',
        viewName: 'default',
        name: 'aspnet_Membership:default',
        evidence: 'aspnet_Membership/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ModifiedIP',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Modified IP',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicationId',
      fieldType: 4,
      dbTypeName: 'Guid',
      format: '',
      title: 'Application Id',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Applications',
        viewName: 'default',
        name: 'aspnet_Applications:default',
        evidence: 'aspnet_Applications/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'LicenceNumber',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Licence Number',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PermitProcessName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'Permit Process Name',
      description: '',
      maxLength: '2147483647',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApprovalResultL1',
      fieldType: 6,
      dbTypeName: 'Int16',
      format: '',
      title: 'Approval Result L1',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApprovalResultL2',
      fieldType: 6,
      dbTypeName: 'Int16',
      format: '',
      title: 'Approval Result L2',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'SpecialistExtraPayment',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'Specialist Extra Payment',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'SpecialistExtraPaymentAmount',
      fieldType: 8,
      dbTypeName: 'Decimal',
      format: '',
      title: 'Specialist Extra Payment Amount',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExpertResult',
      fieldType: 6,
      dbTypeName: 'Int16',
      format: '',
      title: 'Expert Result',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExpertComment',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Expert Comment',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExpertExtraPayment',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'Expert Extra Payment',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExpertExtraPaymentAmount',
      fieldType: 8,
      dbTypeName: 'Decimal',
      format: '',
      title: 'Expert Extra Payment Amount',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExpertRevertReason',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Expert Revert Reason',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'SpecialistRevertReason',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Specialist Revert Reason',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AcceptanceResult',
      fieldType: 6,
      dbTypeName: 'Int16',
      format: '',
      title: 'Acceptance Result',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AcceptanceDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Acceptance Date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RejectionReason',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Rejection Reason',
      description: '',
      maxLength: '256',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'SentForDelivery',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'Sent For Delivery',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ExpertID',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'Expert',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Membership',
        viewName: 'default',
        name: 'aspnet_Membership:default',
        evidence: 'aspnet_Membership/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'OfficerID',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'Officer',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Membership',
        viewName: 'default',
        name: 'aspnet_Membership:default',
        evidence: 'aspnet_Membership/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DispatchedBy',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'Dispatched By',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Membership',
        viewName: 'default',
        name: 'aspnet_Membership:default',
        evidence: 'aspnet_Membership/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApprovalL1By',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'Approval L1 By',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Membership',
        viewName: 'default',
        name: 'aspnet_Membership:default',
        evidence: 'aspnet_Membership/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApprovalL2By',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'Approval L2 By',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Membership',
        viewName: 'default',
        name: 'aspnet_Membership:default',
        evidence: 'aspnet_Membership/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'SignedBy',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'Signed By',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Membership',
        viewName: 'default',
        name: 'aspnet_Membership:default',
        evidence: 'aspnet_Membership/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CurrentRole',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Current Role',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Comments',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'Comments',
      description: '',
      maxLength: '2147483647',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'IsUnread',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'Is Unread',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Applicant Address',
      description: '',
      maxLength: '1000',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'StateName',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'State Name',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ProcessID',
      fieldType: 4,
      dbTypeName: 'Guid',
      format: '',
      title: 'Process ID',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CurrentState',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Current State',
      description: '',
      maxLength: '200',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PermitID',
      fieldType: 4,
      dbTypeName: 'Int32',
      format: '',
      title: 'Permit ID',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PermitTypeIdGuid',
      fieldType: 4,
      dbTypeName: 'Guid',
      format: '',
      title: 'Permit Type Id Guid',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'SubmittedDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Submitted Date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AdditionalDeclaration',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'Additional Declaration',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Re Object Address',
      description: '',
      maxLength: '1000',
      isSystemRequired: false,
      readonly: true,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TeamId',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'Team Id',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'aspnet_Teams',
        viewName: 'lookup',
        name: 'aspnet_Teams:lookup',
        evidence: 'aspnet_Teams/lookup',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'AuthCEMT',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'AuthCEMT',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormAuthCEMT',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Transport',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Transport',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormTransport',
        gridName: 'InterbusCFP',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ActivityStation',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'ActivityStation',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormActivityStation',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'RouteLength',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'RouteLength',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TransportModel',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'TransportModel',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TransportWeight',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'TransportWeight',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CoveringSketch',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'CoveringSketch',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormCoveringSketch',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'BorderActivities',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'BorderActivities',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormBorderActivities',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ArmsAppointment',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'ArmsAppointment',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_ArmsAppointment',
        viewName: 'default',
        name: 'EP_DIC_ArmsAppointment:default',
        evidence: 'EP_DIC_ArmsAppointment/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Arms',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Arms',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormArms',
        gridName: 'Arms',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'ParentID',
            value: '1',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ArmsCatB',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'ArmsCatB',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormArmsCategories',
        gridName: 'CategoryB',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'ParentID',
            value: '2',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ArmsCatC',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'ArmsCatC',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormArmsCategories',
        gridName: 'CategoryC',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'ParentID',
            value: '3',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ArmsCatD',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'ArmsCatD',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormArmsCategories',
        gridName: 'CategoryD',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'ParentID',
            value: '4',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Ammunition',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Ammunition',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormArms',
        gridName: 'Ammunition',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'ParentID',
            value: '2',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ReservePipes',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'ReservePipes',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormArms',
        gridName: 'ReservePipe',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'ParentID',
            value: '3',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Studies',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Studies',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormStudies',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'LegalWork',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'LegalWork, months',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TraineeWork',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'TraineeWork, months',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Language',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Language',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Languages',
        viewName: 'default',
        name: 'EP_DIC_Languages:default',
        evidence: 'EP_DIC_Languages/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Discipline',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Discipline',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Subjects',
      fieldType: 4,
      dbTypeName: 'String',
      format: 'textarea',
      title: 'Subjects',
      description: '',
      maxLength: '1024',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Sources',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'Sources',
      description: '',
      maxLength: '1024',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Consent',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'Consent',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Warranties',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: 'textarea',
      title: 'Warranties',
      description: '',
      maxLength: '500',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Channels',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Channels',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormRadio',
        gridName: 'Channels',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'Type',
            value: '1',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Network',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Network',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormRadio',
        gridName: 'Network',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'Type',
            value: '2',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Resources',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Resources',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormRadio',
        gridName: 'Resources',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'Type',
            value: '3',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'RadioActivities',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'RadioActivities',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_RadioActivities',
        viewName: 'default',
        name: 'EP_DIC_RadioActivities:default',
        evidence: 'EP_DIC_RadioActivities/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: true,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'NuclearActivity',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'NuclearActivity',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_NuclearActivities',
        viewName: 'default',
        name: 'EP_DIC_NuclearActivities:default',
        evidence: 'EP_DIC_NuclearActivities/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PartialNuclear',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'PartialNuclear',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_NuclearPartial',
        viewName: 'default',
        name: 'EP_DIC_NuclearPartial:default',
        evidence: 'EP_DIC_NuclearPartial/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'OriginAddress',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'OriginAddress',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Vehicles',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Vehicles',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormTransport',
        gridName: 'Vehicles',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Routes',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Routes',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormRoute',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'LegalForm',
      fieldType: 1,
      dbTypeName: 'Int16',
      format: '',
      title: 'LegalForm',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_LegalForm',
        viewName: 'default',
        name: 'EP_DIC_LegalForm:default',
        evidence: 'EP_DIC_LegalForm/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Passport',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Serial No. Passport',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'IDNO',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'IDNO',
      description: '',
      maxLength: '13',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'IDNP',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'IDNP',
      description: '',
      maxLength: '13',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Applicant Address Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'default',
        name: 'EP_DIC_Countries:default',
        evidence: 'EP_DIC_Countries/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressLine1',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Applicant Address Line1',
      description: '',
      maxLength: '250',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantAddressLine2',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Applicant Address Line2',
      description: '',
      maxLength: '250',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DesignerCountry',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'Designer Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DesignerAddressLine1',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Designer Address Line1',
      description: '',
      maxLength: '250',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Beneficiary Address Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'default',
        name: 'EP_DIC_Countries:default',
        evidence: 'EP_DIC_Countries/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressCountry',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Representative Address Country',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Countries',
        viewName: 'default',
        name: 'EP_DIC_Countries:default',
        evidence: 'EP_DIC_Countries/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressLine1',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Beneficiary Address Line1',
      description: '',
      maxLength: '200',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BeneficiaryAddressLine2',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Beneficiary Address Line2',
      description: '',
      maxLength: '200',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressLine2',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative Address Line2',
      description: '',
      maxLength: '200',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressLine1',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Representative Address Line1',
      description: '',
      maxLength: '200',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Days',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Days',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Days',
        viewName: 'default',
        name: 'EP_DIC_Days:default',
        evidence: 'EP_DIC_Days/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Property',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Property',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Property',
        viewName: 'default',
        name: 'EP_DIC_Property:default',
        evidence: 'EP_DIC_Property/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PowerOfAttorney',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'PowerOfAttorney',
      description: '',
      maxLength: '200',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PermitNumber',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'PermitNumber',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CustomsCode',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Customs code',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'OCPO',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'OCPO',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Branches',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Branches',
      description: 'Create New Branches',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_Subdivisions',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'LegalEntityId',
            value: '[LegalEntityId]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'BranchesSubActivities',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'BranchesSubActivities',
      description: 'Edit and Select Sub Activities',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_Subdivisions',
        gridName: 'SubActivities',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'LegalEntityId',
            value: '[LegalEntityId]',
          },
          {
            name: 'ActivityType',
            value: '[ActivityType]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'LegalEntityId',
      fieldType: 1,
      dbTypeName: 'Guid',
      format: '',
      title: 'LegalEntityId',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_LegalEntities',
        viewName: 'default',
        name: 'EP_LegalEntities:default',
        evidence: 'EP_LegalEntities/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CountryCefta',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'CountryCefta',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'vw_EP_CeftaCountries',
        viewName: 'default',
        name: 'vw_EP_CeftaCountries:default',
        evidence: 'vw_EP_CeftaCountries/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DieselFuel',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'DieselFuel',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'DieselFuel',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'TechDomains',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'DieselFuel',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormDomains',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'TransmittingEq',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'TransmittingEq',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormRadioList',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'Category',
            value: '1',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ReceivingEq',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'ReceivingEq',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormRadioList',
        gridName: 'Receiving',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'Category',
            value: '2',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'RadioEq',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'RadioEq',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormRadioList',
        gridName: 'Radio',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'Category',
            value: '3',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Ship',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Ship',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_DIC_Ships',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Foodstuffs',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Foodstuffs',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'Foodstuffs',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Consumption',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Consumption',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Consumption',
        viewName: 'default',
        name: 'EP_DIC_Consumption:default',
        evidence: 'EP_DIC_Consumption/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DateTo',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Date To',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'DateFrom',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'DateFrom',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Veterinary',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Veterinary',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'Veterinary',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Deposit',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Deposit',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_DepositTypes',
        viewName: 'default',
        name: 'EP_DIC_DepositTypes:default',
        evidence: 'EP_DIC_DepositTypes/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RadioLicence',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Radio Licence',
      description: '',
      maxLength: '50',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PrimaryElectricalSupply',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Primary Electrical Supply',
      description: '',
      maxLength: '250',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'EmercyElectricalSupply',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Emercy Electrical Supply',
      description: '',
      maxLength: '250',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'SelectiveCallNumberRequired',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'Selective Call Number Required',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TradingArea',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Trading Area',
      description: '',
      maxLength: '150',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectEmail',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ReObjectEmail',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ReObjectOffice',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ReObjectOffice',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantFax',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ApplicantFax',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Web',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'Web',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantOffice',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ApplicantOffice',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PublicNetwork',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'PublicNetwork',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormNetworkPub',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'NetworkServices',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'NetworkServices',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormNetworkServ',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Activities',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Activities',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormLicenseActivities',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'PermitTypeId',
            value: '[PermitTypeId]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'SubActivities',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Sub activities',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormSubActivities',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'LegalEntityId',
            value: '[LegalEntityId]',
          },
          {
            name: 'PermitTypeId',
            value: '[PermitTypeId]',
          },
          {
            name: 'ActivityType',
            value: '[ActivityType]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Machines',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Machines',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormCalcMachine',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'StructuralUnits',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'StructuralUnits',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_Subdivisions',
        gridName: 'StructuralUnits',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'MetrologyUnits',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Branches',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_Subdivisions',
        gridName: 'MetrologicUnits',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ContactEmail',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ContactEmail',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CPAS',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'CPAS',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CorporateEmail',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'CorporateEmail',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CorporateFax',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'CorporateFax',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CorporatePhone',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'CorporatePhone',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ContactIDNP',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'ContactIDNP',
      description: '',
      maxLength: '13',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TechProfiles',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'TechProfiles',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProfiles',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'DepositOperations',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'DepositOperations',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormDepositOp',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'DepositManipulations',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'DepositManipulations',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormDepositMa',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ProductsWarehouse',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'ProductsWarehouse',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'Warehouse',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Facilities',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Facilities',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormFacility',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ProductsGroup',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'ProductsGroup',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormProducts',
        gridName: 'Commercial',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'OffDays',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'OffDays',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormDaysOff',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'Substance',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Substance',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_MedicalProducts',
        viewName: 'default',
        name: 'EP_DIC_MedicalProducts:default',
        evidence: 'EP_DIC_MedicalProducts/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PassportSeries',
      fieldType: 4,
      dbTypeName: 'String',
      format: '',
      title: 'Passport Series',
      description: '',
      maxLength: '1',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PurposeImport',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Purpose Import',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_MedicalPurpose',
        viewName: 'default',
        name: 'EP_DIC_MedicalPurpose:default',
        evidence: 'EP_DIC_MedicalPurpose/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TemplateLangID',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'Permit lang',
      description: '',
      maxLength: '100',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Languages',
        viewName: 'default',
        name: 'EP_DIC_Languages:default',
        evidence: 'EP_DIC_Languages/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'RepresentativeAddressTheSame',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: '',
      title: 'Representative Address The Same',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CaseType',
      fieldType: 1,
      dbTypeName: 'Int16',
      format: '',
      title: 'Case Type',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_CaseTypes',
        viewName: 'default',
        name: 'EP_DIC_CaseTypes:default',
        evidence: 'EP_DIC_CaseTypes/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CommercialObjectType',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'CommercialObjectType',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Subactivities',
        viewName: 'default',
        name: 'EP_DIC_Subactivities:default',
        evidence: 'EP_DIC_Subactivities/default',
      },
      bindings: [
        {
          from: 'ActivityType',
          to: 'ActivityId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TimeFrom',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'TimeFrom',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_WorkTime',
        viewName: 'default',
        name: 'EP_DIC_WorkTime:default',
        evidence: 'EP_DIC_WorkTime/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: true,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'TimeTo',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'TimeTo',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_WorkTime',
        viewName: 'default',
        name: 'EP_DIC_WorkTime:default',
        evidence: 'EP_DIC_WorkTime/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: true,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PauseFrom',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'PauseFrom',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_WorkTime',
        viewName: 'default',
        name: 'EP_DIC_WorkTime:default',
        evidence: 'EP_DIC_WorkTime/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: true,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'PauseTo',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'PauseTo',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_WorkTime',
        viewName: 'default',
        name: 'EP_DIC_WorkTime:default',
        evidence: 'EP_DIC_WorkTime/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: true,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Nonstop',
      fieldType: 9,
      dbTypeName: 'Boolean',
      format: 'radio',
      title: 'Nonstop',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CheckList',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'CheckList',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormConditionsList',
        gridName: 'amendment',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'CaseType',
            value: '[CaseType]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ExtentionDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Extention Date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CheckListEF',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'CheckListEF',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormConditionsList',
        gridName: 'amendmentEF',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'CaseType',
            value: '[CaseType]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ArmsDestination',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Arms Destination',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormArmsDestination',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'WeaponType',
      fieldType: 2,
      dbTypeName: 'Int32',
      format: '',
      title: 'WeaponType',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_WeaponTypes',
        viewName: 'default',
        name: 'EP_DIC_WeaponTypes:default',
        evidence: 'EP_DIC_WeaponTypes/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: false,
      isDynamicDropDown: true,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'ApplicantBirthLocality',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'ApplicantBirthLocality',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_Localities',
        viewName: 'default',
        name: 'EP_DIC_Localities:default',
        evidence: 'EP_DIC_Localities/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BranchesNARE',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'BranchesNARE',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_Subdivisions',
        gridName: 'BranchesNARE',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'LegalEntityId',
            value: '[LegalEntityId]',
          },
          {
            name: 'ActivityType',
            value: '[ActivityType]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'QuantityUnitsW',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'QuantityUnitsW',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_QuantityUnits',
        viewName: 'medicine',
        name: 'EP_DIC_QuantityUnits:medicine',
        evidence: 'EP_DIC_QuantityUnits/medicine',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CommercialName',
      fieldType: 4,
      dbTypeName: 'StringUnicode',
      format: '',
      title: 'CommercialName',
      description: '',
      maxLength: '255',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CopiesNumber',
      fieldType: 6,
      dbTypeName: 'Int32',
      format: '',
      title: 'Copies No.',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'Certificates',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'Certificates',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormCertificates',
        gridName: 'default',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'PermitTypeId',
            value: '[PermitTypeId]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'BlankDocumentTypes',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'BlankDocumentTypes',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_CertificateTypes',
        viewName: 'default',
        name: 'EP_DIC_CertificateTypes:default',
        evidence: 'EP_DIC_CertificateTypes/default',
      },
      bindings: [
        {
          from: 'PermitTypeId',
          to: 'PermitTypeId',
        },
      ],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'BranchesStations',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'BranchesStations',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_Subdivisions',
        gridName: 'BranchesStations',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'LegalEntityId',
            value: '[LegalEntityId]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'TransportPassenger',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'TransportPassenger',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormTransport',
        gridName: 'Interbus',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'CertificatesCEMT',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'CertificatesCEMT',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormCertificates',
        gridName: 'MultilateralCEMT',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'PermitTypeId',
            value: '[PermitTypeId]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'AuthTransportTraffic',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'AuthTransportTraffic',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormCertificates',
        gridName: 'TransportTraffic',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
          {
            name: 'PermitTypeId',
            value: '[PermitTypeId]',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'ComActivityType',
      fieldType: 1,
      dbTypeName: 'Int32',
      format: '',
      title: 'ComActivityType',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      extract: {
        tableName: 'EP_DIC_CAEM2',
        viewName: 'default',
        name: 'EP_DIC_CAEM2:default',
        evidence: 'EP_DIC_CAEM2/default',
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: true,
      isSingleLookup: true,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
    {
      name: 'CommercialActivities',
      fieldType: 11,
      dbTypeName: '',
      format: '',
      title: 'CommercialActivities',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      slaveGrid: {
        tableName: 'EP_FormTraidingActivities',
        gridName: 'CommerciaActivities',
        columns: [
          {
            name: 'FormID',
            type: 'parentkey',
          },
        ],
      },
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: true,
      hasRelation: false,
    },
    {
      name: 'CancelationDate',
      fieldType: 10,
      dbTypeName: 'DateTime',
      format: '',
      title: 'Cancelation Date',
      description: '',
      maxLength: '',
      isSystemRequired: false,
      readonly: false,
      uiMask: '00111',
      bindings: [],
      isHidden: false,
      isRequiredForGrid: false,
      isRequiredForForm: false,
      isValidForGrid: true,
      isValidForForm: true,
      allowCreate: true,
      isValidForReport: false,
      isExtractable: false,
      isSingleLookup: false,
      isDynamicDropDown: false,
      isNonValueType: false,
      hasRelation: false,
    },
  ],
};
